<template>
    <div class="NewDocument" style="min-height:800px;">
        <div class="container">
            <div class="row">
                <div class="chapter-block col-md-4 col-lg-3" v-for="chapterLabel in ChapterLabels" style="margin-top:20px;">

                    <!--<h4 class="chapter-title">{{ chapterLabel }}</h4>-->
                    <!--<p v-for="formMembership in GetFormMembershipsFromChapterLabel(chapterLabel)" @click="HandleFormMembershipClick(formMembership)" class="form-membership">
                {{ formMembership.Form.Label }}
            </p>-->
                    <select class="form-control" @change="OnFormSelectChange()" v-model="FormSelectItem">
                        <option value="" hidden>{{ chapterLabel }}</option>
                        <option v-for="formMembership in GetFormMembershipsFromChapterLabel(chapterLabel)" :value="formMembership">{{ formMembership.Form.Label }}</option>
                    </select>

                </div>
            </div>
            <div class="row" v-if="AllowBulkUploads">
                <div class="col">
                    <p class="link-like" @click="OpenBulkUploadDialog()">BULK UPLOAD SCANNED DOCUMENTS</p>
                </div>
            </div>
        </div>
       

        <b-modal ref="newdocstartend" title="Select Time Range" size="md" hide-footer>
            <b-container>
                <b-form @submit="ContinueWithFormSelect">
                    <div class="form-group">
                        <label>Range From:</label>
                        <flat-pickr class="form-control" required :config="DateConfig" v-model="StartDate"></flat-pickr>
                    </div>
                    <div class="form-group">
                        <label>Range To:</label>
                        <flat-pickr class="form-control" required :config="DateConfig" v-model="EndDate"></flat-pickr>
                    </div>
                    <div class="form-group">
                        <label>Carry Forward Last Document:</label>
                        <select class="form-control" required v-model="CarryForwardLastDocument">
                            <option :value="false">No</option>
                            <option :value="true">Yes</option>
                        </select>
                    </div>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelStartEnd()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit">
                                GO TO FORM
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>

        <b-modal ref="newdocstartendnocarry" title="Select Time Range" size="md" hide-footer>
            <b-container>
                <b-form @submit="ContinueWithFormSelect">
                    <div class="form-group">
                        <label>Range From:</label>
                        <flat-pickr class="form-control" required :config="DateConfig" v-model="StartDate"></flat-pickr>
                    </div>
                    <div class="form-group">
                        <label>Range To:</label>
                        <flat-pickr class="form-control" required :config="DateConfig" v-model="EndDate"></flat-pickr>
                    </div>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelStartEnd()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit">
                                GO TO FORM
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>

        <b-modal ref="informalrelationshipschecker" title="Verify Informal Relationships" size="lg" hide-footer>
            <b-container>
                <b-form @submit="ContinueWithFormSelect">
                    <InformalRelationshipsDisplayAndEdit :edit-mode="true"
                                                         :chart-id="ChartRecordId"
                                                         client-first-name="Client" />
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelInformal()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit">
                                GO TO FORM
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>

        <b-modal ref="bulkuploaddialog" title="Bulk Upload Scanned Documents" size="lg" hide-footer>
            <b-container>
                <b-form ref="bulkfileuploadform" @submit="SendBulkFilesForProcessing">
                    <p>Upload scanned files with QR codes.  Every page needs a specific QR code on it supplied to you.  All documents must be dated the same date.</p>
                    <b-form-group label="Scanned File:">
                        <b-form-file accept=".pdf"
                                     name="FileData"
                                     :required="true"
                                     drop-placeholder="Drop word or pdf here..."></b-form-file>
                    </b-form-group>
                    <b-form-group label="Date of Documents:">
                        <flat-pickr class="form-control" required :config="DateConfig" name="FilesDate"></flat-pickr>
                    </b-form-group>
                    <b-row class="modal-btn-row">
                        <div class="modal-btn-row-div">
                            <b-button size="md" variant="secondary" @click="CancelBulkUploadDialog()">
                                CANCEL
                            </b-button>
                            <b-button size="md" variant="success" type="submit">
                                UPLOAD DOCUMENTS
                            </b-button>
                        </div>
                    </b-row>
                </b-form>
            </b-container>
        </b-modal>

        <b-modal ref="bulkuploadconfirmationdialog" title="Confirm Uploaded Documents" size="lg" hide-footer>
            <b-container>
                <div v-for="item in BulkConfirmationItems">
                    <p><a :href="item.FileURL" target="_blank">{{item.FormLabel}}</a></p>
                </div>
                <b-row class="modal-btn-row">
                    <div class="modal-btn-row-div">
                        <b-button size="md" variant="secondary" @click="CancelBulkUploadConfirmationDialog()">
                            CANCEL
                        </b-button>
                        <b-button size="md" variant="success" type="button" @click="ConfirmBulkUploads()">
                            CONFIRM
                        </b-button>
                    </div>
                </b-row>
            </b-container>
        </b-modal>

        <DocumentEditor ref="document-editor-modal-component" :chart-record-id-preset="ChartRecordId" :editing-submitted-document="false" />
    </div>
</template>

<script>
    //import icons
    //import { library } from '@fortawesome/fontawesome-svg-core';
    //import { faEdit } from '@fortawesome/free-solid-svg-icons';
    //library.add(faEdit);

    //import CaseFileChapter from "./CaseFileChapter.vue";
    import flatPickr from 'vue-flatpickr-component';
    import 'flatpickr/dist/flatpickr.css';
    import DocumentEditor from "./DocumentEditor.vue";
    import InformalRelationshipsDisplayAndEdit from '../ItemEditors/InformalRelationshipsDisplayAndEdit.vue';

    export default {
        props: [
            "ChartRecordId",
            "FormMembershipsImport",
            "AllowBulkUploads",
            "NewDocPayload",
            "ChartType"
        ],
        data: function () {
            return {
                FormMemberships: [],
                FormSelectItem: "",
                TargetFormSubProgramMembership: {},
                StartDate: "",
                EndDate: "",
                CarryForwardLastDocument: false,
                DateConfig: {
                    dateFormat: 'Y-m-d',
                    allowInput: true,
                    altInput: true,
                    altFormat: 'm/d/Y'
                },
                BulkConfirmationItems: []
            }
        },
        methods: {
            GetFormMemberships() {
                this.$MasterAPI.ExecuteRequest("GET", "GenMod/Options/FormMemberships", { ChartId: this.ChartRecordId, ChartType: this.ChartType }, this.GetFormMembershipsSuccess, null, true);
            },
            GetFormMembershipsSuccess(response) {
                this.FormMemberships = response.data.data;

            },
            OnFormSelectChange: function () {
                
                if (this.FormSelectItem != "") {
                    if (this.FormSelectItem.SectionName == "QuarterlyReports" || this.FormSelectItem.SectionName == "CPACaregiverSupportPlan" || this.FormSelectItem.SectionName == "ServiceAndSupervisionPlans" || this.FormSelectItem.SectionName == "CaregiverSupportPlanAndQuarterlyReports" || this.FormSelectItem.SectionName == "TherapeuticSupportService") {
                        //show start/end day prompt
                        this.StartDate = "";
                        this.EndDate = "";
                        this.CarryForwardLastDocument = false;
                        this.$refs['newdocstartend'].show();
                    } else if (this.FormSelectItem.SectionName == "NeedsandServicePlans" || this.FormSelectItem.SectionName == "QuarterlyTreatmentPlans" || this.FormSelectItem.SectionName == "PlansOfCare") {
                        this.$refs['informalrelationshipschecker'].show();
                    } else if (this.FormSelectItem.SectionName == "MonthlySummaries") {
                        this.StartDate = "";
                        this.EndDate = "";
                        this.CarryForwardLastDocument = false;
                        this.$refs['newdocstartendnocarry'].show();
                    }


                    else {
                        this.StartDate = "";
                        this.EndDate = "";
                        this.CarryForwardLastDocument = false;
                        this.$refs['document-editor-modal-component'].ShowNewDocumentModal(this.FormSelectItem);
                        this.FormSelectItem = "";
                    }
                }
            },
            ContinueWithFormSelect: function (e) {
                e.preventDefault();
                this.$refs['newdocstartend'].hide();
                this.$refs['newdocstartendnocarry'].hide();
                this.$refs['informalrelationshipschecker'].hide();
                if (this.FormSelectItem != "") {
                    this.$refs['document-editor-modal-component'].ShowNewDocumentModal(this.FormSelectItem, this.StartDate, this.EndDate, this.CarryForwardLastDocument);
                    this.FormSelectItem = "";
                    
                }
            },
            CancelStartEnd: function () {
                this.$refs['newdocstartend'].hide();
            },
            CancelInformal: function () {
                this.$refs['informalrelationshipschecker'].hide();
            },
            /*
             * Returns a string[] with distinct section labels that match the specified chapter string. MARKED FOR DELETION
             */ 
            GetSectionLabelsFromChapterLabel: function (chapterLabel) {
                let output = [];
                this.FormMemberships.map(function (key, index) {
                    if (key.ChapterLabel == chapterLabel && !output.includes(key.SectionLabel)) {
                        output.push(key.SectionLabel);
                    }
                });
                return output;
            },
            GetFormMembershipsFromChapterLabel: function (chapterLabel) {
                let output = [];
                this.FormMemberships.map(function (key, index) {
                    if (key.ChapterLabel == chapterLabel) {
                        output.push(key);
                    }
                });
                return output;
            },
            //BULK UPLOAD
            OpenBulkUploadDialog() {
                
                this.$refs['bulkuploaddialog'].show();
                this.$refs['bulkfileuploadform'].reset();
            },
            CancelBulkUploadDialog() {
                this.$refs['bulkuploaddialog'].hide();
            },
            CancelBulkUploadConfirmationDialog() {
                this.$refs['bulkuploadconfirmationdialog'].hide();
            },
            SendBulkFilesForProcessing(e) {
                e.preventDefault();
                let form = this.$refs['bulkfileuploadform'];
                let formData = new FormData(form);

                formData.append("ChartID", this.ChartRecordId);

                this.$MasterAPI.ExecuteRequest("POST", "BulkDocumentUploads/UploadFiles", formData, this.SendBulkFilesForProcessingSuccess, () => { }, true);
            },
            SendBulkFilesForProcessingSuccess(response) {
                this.BulkConfirmationItems = response.data.data;
                this.$refs['bulkuploaddialog'].hide();
                this.$refs['bulkuploadconfirmationdialog'].show();
            },
            ConfirmBulkUploads() {
                let documentIds = [];
                this.BulkConfirmationItems.forEach(function (item) {
                    documentIds.push(item.DocumentID);
                });
                this.$MasterAPI.ExecuteRequest("POST", "BulkDocumentUploads/ConfirmFiles", {DocumentIDs: documentIds, ChartID: this.ChartRecordId}, this.ConfirmBulkUploadsSuccess, () => { }, true);
            },
            ConfirmBulkUploadsSuccess(response) {
                this.$refs['bulkuploadconfirmationdialog'].hide();
            },

            formatDate (value, fmt = 'D MMM YYYY') {
              return (value == null)
                ? ''
                : moment(value, 'YYYY-MM-DD').format(fmt)
            },
        },
        components: {
            DocumentEditor,
            flatPickr,
            InformalRelationshipsDisplayAndEdit
        },
        watch: {
            FormMembershipsImport: function (newVal) {
                if (newVal && newVal.length > 0) {
                    this.FormMemberships = newVal;
                }
            }
        },
        computed: {
            ChapterLabels: function () {
                let output = [];
                this.FormMemberships.map(function (key, index) {
                    if (!output.includes(key.ChapterLabel)) {
                        output.push(key.ChapterLabel);
                    }
                });
                return output;
            },
        },
        mounted: function () {
            let vm = this;
            if (this.FormMembershipsImport == null || this.FormMembershipsImport.length == 0 || this.FormMembershipsImport == undefined) {
                this.GetFormMemberships();
            } else {
                this.FormMemberships = this.FormMembershipsImport;
            }
            if (this.NewDocPayload && this.NewDocPayload.Intent == "NewDoc") {
                this.NewDocPayload.Intent == "Cleared";
                this.StartDate = "";
                this.EndDate = "";
                this.CarryForwardLastDocument = false;
                this.FormMemberships.forEach(function (fm) {
                    if (fm.Id.toUpperCase() == vm.NewDocPayload.FormID.toUpperCase()) {
                        vm.$refs['document-editor-modal-component'].ShowNewDocumentModalWithPresets(fm, vm.NewDocPayload);
                    }
                })
                
                this.FormSelectItem = "";
            }
        }
    }
</script>

<style scoped>
    
    .form-membership {
        cursor: pointer;
    }
    .NewDocument {
        background-color: white;
    }
</style>